/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Focus_Plant_TitleInputs */

const en_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome To Forest! Ready to Focus? Plant a seedling!`)
};

const ar_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا بك في Forest! هل أنت مستعد للتركيز؟ ازرع شتلة!`)
};

const de_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen bei Forest! Bereit zur Konzentration? Pflanzen Sie einen Setzling!`)
};

const es_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido a Forest ¿Listo para concentrarte? ¡Planta una semilla!`)
};

const fr_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur Forest ! Prêt à vous concentrer ? Plantez une graine !`)
};

const it_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto in Forest! Pronto a concentrarti? Semina una piantina!`)
};

const ja_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forestへようこそ！集中する準備はできましたか？苗を植えてみましょう！`)
};

const ko_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest에 오신 것을 환영해요! 집중할 준비가 되셨나요? 묘목을 심으세요!`)
};

const pt_br_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boas-vindas ao Forest! Tudo certo para manter o foco? Plante uma muda!`)
};

const ru_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добро пожаловать в Forest! Готовы сосредоточиться? Посадите саженец!`)
};

const th_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยินดีต้อนรับเข้าสู่ Forest! พร้อมที่จะโฟกัสหรือยัง? ปลูกต้นกล้าเลยสิ!`)
};

const tr_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest'a Hoş Geldin! Odaklanmaya hazır mısın? Bir fidan dik!`)
};

const zh_cn_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎你来到 Forest！
每当你需要专注时，就来种下一棵树苗`)
};

const zh_tw_walkturough_focus_plant_title = /** @type {(inputs: Walkturough_Focus_Plant_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歡迎你來到 Forest！
每當你需要專注時，就來種下一棵樹苗`)
};

/**
* | output |
* | --- |
* | "Welcome To Forest! Ready to Focus? Plant a seedling!" |
*
* @param {Walkturough_Focus_Plant_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_focus_plant_title = /** @type {((inputs?: Walkturough_Focus_Plant_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Focus_Plant_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_focus_plant_title(inputs)
	if (locale === "ar") return ar_walkturough_focus_plant_title(inputs)
	if (locale === "de") return de_walkturough_focus_plant_title(inputs)
	if (locale === "es") return es_walkturough_focus_plant_title(inputs)
	if (locale === "fr") return fr_walkturough_focus_plant_title(inputs)
	if (locale === "it") return it_walkturough_focus_plant_title(inputs)
	if (locale === "ja") return ja_walkturough_focus_plant_title(inputs)
	if (locale === "ko") return ko_walkturough_focus_plant_title(inputs)
	if (locale === "pt_br") return pt_br_walkturough_focus_plant_title(inputs)
	if (locale === "ru") return ru_walkturough_focus_plant_title(inputs)
	if (locale === "th") return th_walkturough_focus_plant_title(inputs)
	if (locale === "tr") return tr_walkturough_focus_plant_title(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_focus_plant_title(inputs)
	return zh_tw_walkturough_focus_plant_title(inputs)
});